<template>
    <div>
        <div class="table-values flex flex-nowrap justify-around p-4 pl-11 pt-3 bg-white overflow-x-auto border-b border-[#D9D5EC]"
            :class="{ 'bg-[#F2F0F9]': selected || showactions }">
            <p class="w-3/12 overflow-wrap">{{ shipping?.shippingReference }}</p>
            <p class="w-3/12 ml-2">{{ shipping?.consolidationReference }}</p>
            <p class="w-3/12 ml-2">{{ shipping && shipping.itemCount && shipping.itemCount }}</p>
            <p class="w-5/12 ml-2 overflow-wrap break-words">{{ shipping?.description }}</p>
            <p class="w-3/12 ml-2">{{ shipping?.totalWeight }}</p>
            <p class="w-3/12 ml-2 overflow-wrap">{{ shippingService?.name }}</p>
            <p class="w-4/12 ml-2">{{ shipping?.shippingInstruction }}</p>
            <p class="w-4/12 ml-2 break-all">{{ formatDate(shipping?.estimatedDeliveryDate) }}</p>
        </div>
    </div>

</template>

<script>
import moment from 'moment';

export default {
    components: {
    },
    props: ['shipping', 'count', 'total', "consolidationReference", "shippingService"],
    data() {
        return {
            showactions: false,
            statusDispatch: false,
            putholdModal: false,
            showfinalholdmodal: false,
            successfulDispatch: false,
            showupdateModal: false,
            processhandoffModal: false,
            showProcessFulfillmentModal: false,
            confirmprocesshandoffModal: false,
            requestsentModal: false,
            processreturnmodal: false,
            returndetailsmodal: false,
            returncostmodal: false,
            canceldispatchshow: false,
            putonholdreason: "",
            booking: {}
        }
    },
    mounted() {},
    methods: {
        formatDate(date) {
            return moment(date).format('DD/MM/YY hh:mma')
        },
        capitalize(str) {
            let capitalizedstr = str.charAt(0).toUpperCase() + str.slice(1)

            return capitalizedstr
        },
        showModal(modal) {

            if (modal == 'dispatchmodal') {
                this.statusDispatch = true
            } else if (modal == 'putonholdmodal') {
                this.putholdModal = true
            } else if (modal == 'statusmodal') {
                this.showupdateModal = true
            } else if (modal == 'processhandoffmodal') {
                this.processhandoffModal = true
            } else if (modal == 'processreturnModal') {
                this.processreturnmodal = true
            } else if (modal == 'canceldispatch') {
                this.canceldispatchshow = true
            }
        },

    },
    computed: {
        onDispatch() {
            return this.shipping.dispatchStatus == 'dispatched' || this.shipping.dispatchStatus == 'accidented' || this.shipping.dispatchStatus == 'received' || this.shipping.dispatchStatus == 'delayed' ? true : false
        },
        getLoadWeight() {
            const totalWeight = (this.shipping?.shipmentReceiever || []).reduce((sum, order) => {
                const packageWeight = (order?.packagees || []).reduce((pkgSum, pkg) => {
                    return pkgSum + (Number(pkg?.estimatedWeight) * Number(pkg?.quantity || 1));
                }, 0);

                return sum + packageWeight;
            }, 0);

            return totalWeight;
        },
        getDeliveryNote() {
             const handling = (this.shipping?.shipmentReceiever || []).reduce((sum, order) => {
                const delvryNote = (order?.packagees || []).reduce((pkgSum, pkg) => {
                    return pkgSum + (pkg?.deliveryNote || '');
                }, "");

                return sum + delvryNote;
            }, "");

            return handling || ''
        },
        getDescription() {
          const description = (this.shipping?.shipmentReceiever || []).reduce((sum, order) => {
                const packDescription = (order?.packagees || []).reduce((pkgSum, pkg) => {
                    return pkgSum + pkg?.description;
                }, "");

                return sum + packDescription;
            }, "");


            return description
        }
    }
}
</script>

<style lang="scss" scoped>
.table-values {
    p {
        font-weight: 500;
    }

    .status-green {
        background-color: #09B78A33;
        color: #09B78A;
        font-size: 14px
    }

    .status-yellow {
        background-color: #FFA60033;
        color: #FFA600;
        font-size: 14px
    }

    .status-pale {
        background-color: #10233E33;
        color: #10233E;
        font-size: 14px
    }

    .status-any {
        background-color: #FFA60033;
        color: #FFA600;
        font-size: 14px
    }

    .status-red {
        background-color: #D7263833;
        color: #D72638;
        font-size: 14px;
    }
}

.modals-wrapper {
    button {
        background-color: #FCC210;
        color: #10233E;
        font-weight: 600;
    }
}
</style>